/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MTReminder
 */
export interface MTReminder {
    /**
     * 
     * @type {string}
     * @memberof MTReminder
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof MTReminder
     */
    days_before?: number;
    /**
     * 
     * @type {number}
     * @memberof MTReminder
     */
    hour?: number;
}

/**
 * Check if a given object implements the MTReminder interface.
 */
export function instanceOfMTReminder(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MTReminderFromJSON(json: any): MTReminder {
    return MTReminderFromJSONTyped(json, false);
}

export function MTReminderFromJSONTyped(json: any, ignoreDiscriminator: boolean): MTReminder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'days_before': !exists(json, 'days_before') ? undefined : json['days_before'],
        'hour': !exists(json, 'hour') ? undefined : json['hour'],
    };
}

export function MTReminderToJSON(value?: MTReminder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'days_before': value.days_before,
        'hour': value.hour,
    };
}

